import { render } from "./CreateProgramView.vue?vue&type=template&id=6430cc23&scoped=true"
import script from "./CreateProgramView.vue?vue&type=script&lang=js"
export * from "./CreateProgramView.vue?vue&type=script&lang=js"

import "./CreateProgramView.vue?vue&type=style&index=0&id=6430cc23&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/personal/freelance-sabdulla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6430cc23"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QInput,QToggle,QBtn});
